"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
require("./styles.scss");
var actions_1 = require("../weekDays/actions");
var projectWorklogs_1 = require("./projectWorklogs");
var SpecialWorklogs_1 = require("./SpecialWorklogs");
var utils_1 = require("./utils");
var formatter_1 = require("../../../helpers/formatter");
var constants_1 = require("../../../constants");
var index_1 = require("../../_shared/components/layout/index");
var SearchProject_1 = require("../../searchProject/SearchProject");
var SelectSpecialType_1 = require("../../selectSpecialType/SelectSpecialType");
var Identity_1 = require("../../../model/Identity");
var validations_1 = require("./validations");
require("../../_shared/components/timeline/PopoverTimeline.scss");
var UserTimeline_1 = require("../../../model/UserTimeline");
var PopoverTimeline_1 = require("../components/timeline/PopoverTimeline");
var WorkLogs = /** @class */ (function (_super) {
    __extends(WorkLogs, _super);
    function WorkLogs(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.getProjectWorkLogs = function () {
            var projectWorkLogs = _.chain(_this.props.worklogs)
                .filter(function (worklog) { return !!worklog.project; })
                .groupBy('project')
                .value();
            return _this.props.sortProjectWorkLogs
                ? _this.props.sortProjectWorkLogs(projectWorkLogs)
                : projectWorkLogs;
        };
        _this.state = {
            showSpecialTypesModal: false,
            showProjectsSearchModal: false,
            selectedSpecialType: null,
            isPopoverOpen: false,
        };
        return _this;
    }
    WorkLogs.prototype.updateWorkLogHandler = function (worklog) {
        if (!Number(worklog.approvedHours) && !Number(worklog.hours)) {
            // Delete the worklog if hours equals 0
            this.props.deleteWorkLog(worklog);
        }
        else {
            this.props.updateWorkLog(__assign(__assign({}, worklog), { changedByApprover: true }));
        }
    };
    WorkLogs.prototype.renderSummary = function () {
        var _this = this;
        var _a, _b, _c;
        var summary = (0, utils_1.getProjectHours)(this.props.worklogs);
        var buildSummaryRow = function (title, titleClassName, hours, gpsHours, approvedHours, valueClassName) {
            return { title: title, titleClassName: titleClassName, hours: hours, gpsHours: gpsHours, approvedHours: approvedHours, valueClassName: valueClassName };
        };
        var workHoursCorrespond = (0, validations_1.isCorrespondsHours)(summary.work, this.props.spent_work_time - constants_1.LUNCH_TIME);
        var workClasses = (0, classnames_1.default)({ error: workHoursCorrespond, green: !workHoursCorrespond });
        var travelHoursCorrespond = (0, validations_1.isCorrespondsHours)(summary.travel, this.props.spent_travel_time);
        var travelClasses = (0, classnames_1.default)({ error: travelHoursCorrespond, green: !travelHoursCorrespond });
        var maxTravelTime = _.get(this.props.user, 'settings.travelTime', 0);
        var paidTravelTime = Math.max(0, summary.travel.approvedHours - maxTravelTime);
        var ownTravelTime = summary.travel.approvedHours - paidTravelTime;
        var startWorkdayTimeline = (_a = this.props.timelines) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.type === UserTimeline_1.IUserTimelineType.START_WORKDAY; });
        // tijdstip ingevoerd: Time 'start workday' pressed
        var workdayStartTime = this.props.startTime
            ? moment(this.props.startTime).format('H:mm') : startWorkdayTimeline ? moment(((_b = startWorkdayTimeline === null || startWorkdayTimeline === void 0 ? void 0 : startWorkdayTimeline.notes) === null || _b === void 0 ? void 0 : _b.startTime) || startWorkdayTimeline.createdAt).format('H:mm') : '-';
        // Opgegeven tijd: Start of the workday
        var workdayStartTimeSubmittedAt = this.props.startTimeSubmittedAt
            ? moment(this.props.startTimeSubmittedAt).format('H:mm')
            : startWorkdayTimeline ? moment(((_c = startWorkdayTimeline === null || startWorkdayTimeline === void 0 ? void 0 : startWorkdayTimeline.notes) === null || _c === void 0 ? void 0 : _c.submittedAt) || startWorkdayTimeline.createdAt).format('H:mm') : '-';
        var SUMMARY_TABLE_DATA = [
            buildSummaryRow('Gewerkt', 'bold', summary.work.hours, this.props.spent_work_time, 0),
            buildSummaryRow('Lunchtijd', 'italic', 0, constants_1.LUNCH_TIME, 0),
            buildSummaryRow('Totaal gewerkt', 'total', summary.work.hours, Math.max(0, this.props.spent_work_time - constants_1.LUNCH_TIME), summary.work.approvedHours, workClasses),
            buildSummaryRow('Totaal reistijd', 'total', summary.travel.hours, this.props.spent_travel_time, summary.travel.approvedHours, travelClasses),
            buildSummaryRow('Eigen tijd', 'total', 0, 0, ownTravelTime),
            buildSummaryRow('Betaalde reistijd', '', 0, 0, paidTravelTime),
            buildSummaryRow('Totaal niet gewerkt', 'total', summary.special.hours, 0, summary.special.approvedHours)
        ];
        return (React.createElement(index_1.Wrapper, null,
            React.createElement("div", { className: "summary-header" },
                React.createElement(index_1.Wrapper, { paddingVertical: "4px" },
                    React.createElement("i", { className: "material-icons" }, "assignment_turned_in"),
                    React.createElement("span", null, "Samenvatting"))),
            React.createElement("table", null,
                React.createElement("tbody", { className: "" },
                    React.createElement("tr", null,
                        React.createElement("td", { className: "type-column" }, "Start werkdag opgegeven tijd"),
                        React.createElement("td", { colSpan: 3 }, workdayStartTime)),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "type-column" }, "Start werkdag tijdstip ingevoerd"),
                        React.createElement("td", { colSpan: 3 }, workdayStartTimeSubmittedAt)),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "type-column" }, "Ik werk vandaag tijdlijnen"),
                        React.createElement("td", { colSpan: 3, className: "activity-component" },
                            React.createElement(PopoverTimeline_1.default, { type: UserTimeline_1.IUserTimelineType.WORK_STATE, timelines: this.props.timelines, isPopoverOpen: this.state.isPopoverOpen, anchorClass: "clickable", onClickAnchor: function () { return _this.setState({ isPopoverOpen: !_this.state.isPopoverOpen }); }, onClickOutside: function () { return _this.setState({ isPopoverOpen: false }); } }))),
                    React.createElement("tr", { className: "text-bold" },
                        React.createElement("td", null, ''),
                        React.createElement("td", null, "Werkte"),
                        React.createElement("td", null, "GPS"),
                        React.createElement("td", null, "Goedgekeurd")),
                    _.map(SUMMARY_TABLE_DATA, function (rowData, index) {
                        return React.createElement("tr", { key: index },
                            React.createElement("td", { className: 'type-column ' + rowData.titleClassName }, rowData.title),
                            React.createElement("td", null, formatter_1.Hour.HumanizeTime(rowData.hours)),
                            React.createElement("td", null, formatter_1.Hour.HumanizeTime(rowData.gpsHours)),
                            React.createElement("td", { className: rowData.valueClassName, title: rowData.approvedHours ? "GPS hours is ".concat(rowData.valueClassName === 'green' ? 'higher' : 'less', " than approved hours") : '' }, formatter_1.Hour.HumanizeTime(rowData.approvedHours)));
                    })))));
    };
    WorkLogs.prototype.getWorkLogPermission = function (worklog) {
        var operationPermission = (0, utils_1.getDefaultOperationPermission)();
        operationPermission.APPROVE = _.includes([Identity_1.UserRoles.SUPER_CONSENTER], this.props.identity.role) ||
            _.includes([Identity_1.UserRoles.ADMIN], this.props.identity.role);
        operationPermission.CONTROL =
            operationPermission.APPROVE || _.includes([Identity_1.UserRoles.CONTROLLER], this.props.identity.role);
        operationPermission.UPDATE = worklog.created_by === this.props.identity._id || operationPermission.CONTROL;
        // Hours booked on an hour type that an admin switched off for the portal may
        // only be changed in the HR system (DMHA-1036). They stay visible, but no
        // controller or approver gets to touch them here.
        if (this.isWorkLogTypeSwitchedOff(worklog)) {
            operationPermission.UPDATE = false;
            operationPermission.CONTROL = false;
        }
        return operationPermission;
    };
    WorkLogs.prototype.isWorkLogTypeSwitchedOff = function (worklog) {
        var blocked = worklog.specialType
            ? this.props.blockedSpecialTypes
            : this.props.blockedProjectTypes;
        var code = worklog.specialType
            ? worklog.specialType.code
            : worklog.projectType && worklog.projectType.code;
        if (!blocked || !blocked.length || code === undefined || code === null) {
            return false;
        }
        // An admin receives the switched-off types of every company, so the ones
        // that belong to another company than the employee being looked at must not
        // lock this row.
        var userCompanyIds = ((this.props.user && this.props.user.settings
            && this.props.user.settings.companies) || [])
            .map(function (company) { return (typeof company === 'object' && company !== null ? company._id : company); })
            .map(function (companyId) { return "".concat(companyId); });
        return blocked.some(function (type) {
            if ("".concat(type.code) !== "".concat(code)) {
                return false;
            }
            if (type.companyId && userCompanyIds.length) {
                return userCompanyIds.indexOf("".concat(type.companyId)) > -1;
            }
            return true;
        });
    };
    WorkLogs.prototype.createDefaultWorkLog = function () {
        return {
            hours: 0,
            valid: true,
            approvedHours: 1,
            owner: this.props.user._id,
            date_worked: this.props.date,
            created_by: this.props.identity._id,
            changedByApprover: true,
        };
    };
    WorkLogs.prototype.addWorkLog = function (project) {
        var projectTypes = this.getProjectTypes(project._id);
        var projectType = _.find(projectTypes, function (type) { return (type.code.toString() === '1010' // type: Werkuren
        ); });
        if (!projectType) {
            projectType = _.find(projectTypes, function (type) { return (type.code.toString() === '1210' // type: Reisuren
            ); });
        }
        if (!projectType) {
            projectType = _.find(projectTypes, function (type) { return (!!type.code.toString() // type: Any
            ); });
        }
        // Skip if logs for all project types were created
        if (!projectTypes.length || !projectType) {
            return;
        }
        var newLog = __assign(__assign({}, this.createDefaultWorkLog()), { project: project._id, projectType: projectType });
        this.props.createWorkLog(newLog);
    };
    WorkLogs.prototype.createOrUpdateSpecialWorkLog = function (subType, description) {
        if (!this.state.selectedSpecialType) {
            var newLog = __assign(__assign({}, this.createDefaultWorkLog()), { description: description, specialType: subType });
            this.props.createWorkLog(newLog);
        }
        else {
            var specialTypeWorklog = __assign(__assign({}, this.state.selectedSpecialType), { description: description, specialType: subType });
            this.updateWorkLogHandler(specialTypeWorklog);
        }
    };
    WorkLogs.prototype.getProjectTypes = function (projectId, worklog) {
        var projectWorkLogs = _.chain(this.props.worklogs)
            .filter(function (worklog) { return !!worklog.project; })
            .groupBy('project')
            .value();
        var existedProjectTypes = _.map(projectWorkLogs[projectId], function (worklog) { return worklog.projectType && worklog.projectType.code.toString() || '0'; });
        return _.filter(this.props.projectTypes, function (type) {
            // Show current worklog's project type
            if (worklog && worklog.projectType
                && worklog.projectType.code.toString() === type.code.toString()) {
                return true;
            }
            // Hide already selected project types
            if (_.includes(existedProjectTypes, type.code.toString())) {
                return false;
            }
            return true;
        });
    };
    WorkLogs.prototype.getSpecialTypes = function (worklog) {
        var specialWorkLogs = _.chain(this.props.worklogs)
            .filter(function (worklog) { return !!worklog.specialType; })
            .value();
        var existedSpecialTypes = _.map(specialWorkLogs, function (worklog) { return worklog.specialType && worklog.specialType.code.toString() || '0'; });
        // ADMIN/SUPERADMIN receive worktypes for every company at login;
        // narrow the dropdown to the edited user's companies so they only
        // see types relevant to that user.
        var identityRole = this.props.identity && this.props.identity.role;
        var isAdminLike = identityRole === Identity_1.UserRoles.ADMIN || identityRole === Identity_1.UserRoles.SUPERADMIN;
        var editedUserCompanyIds = isAdminLike
            ? ((this.props.user && this.props.user.settings && this.props.user.settings.companies) || [])
                .map(function (c) { return (typeof c === 'object' && c !== null ? c._id : c); })
            : null;
        return _.filter(this.props.specialTypes, function (type) {
            // Show current worklog's special type
            if (worklog && worklog.specialType
                && worklog.specialType.code.toString() === type.code.toString()) {
                return true;
            }
            // Hide already selected special types
            if (_.includes(existedSpecialTypes, type.code.toString())) {
                return false;
            }
            // Admin/superadmin: keep global (no company) types plus types
            // belonging to one of the edited user's companies.
            if (editedUserCompanyIds && type.companyId
                && editedUserCompanyIds.indexOf(type.companyId) === -1) {
                return false;
            }
            return true;
        });
    };
    WorkLogs.prototype.renderWorkLogTableHeader = function (isSpecialType) {
        if (isSpecialType === void 0) { isSpecialType = false; }
        return (React.createElement(index_1.Wrapper, { className: "project-header", paddingVertical: "10px" },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "type-column" }, "Type"),
                        React.createElement("th", null, isSpecialType ? 'Omschrijving' : 'Ingevuld'),
                        React.createElement("th", null, "GPS"),
                        React.createElement("th", null, "Uur"))))));
    };
    WorkLogs.prototype.render = function () {
        var _this = this;
        var projectWorkLogs = this.getProjectWorkLogs();
        var specialWorkLogs = _.chain(this.props.worklogs)
            .filter(function (worklog) { return !!worklog.specialType; })
            .value();
        var addButtons = React.createElement(index_1.Wrapper, { className: 'add-worklog-button-wrapper' },
            React.createElement(index_1.Row, { justifyContent: "space-between" },
                React.createElement("span", { onClick: function () { return _this.setState({ showProjectsSearchModal: true }); }, className: "button" }, "Werklocatie toevoegen"),
                React.createElement("span", { onClick: function () { return _this.setState({ selectedSpecialType: null, showSpecialTypesModal: true }); }, className: "button" }, "Niet gewerkte uren"),
                React.createElement(SearchProject_1.default, { open: this.state.showProjectsSearchModal, onClose: function () { return _this.setState({ showProjectsSearchModal: false }); }, worklogs: this.props.worklogs, onProjectSelected: function (project) { return _this.addWorkLog(project); }, date: this.props.date, userId: this.props.user._id }),
                React.createElement(SelectSpecialType_1.SelectSpecialType, { open: this.state.showSpecialTypesModal, onClose: function () { return _this.setState({ showSpecialTypesModal: false }); }, onSpecialTypeSelected: (function (subTypeCode, description) {
                        return _this.createOrUpdateSpecialWorkLog(subTypeCode, description);
                    }), specialTypes: this.getSpecialTypes(this.state.selectedSpecialType), selectedSpecialType: this.state.selectedSpecialType || null })));
        var renderProjectWorkLogs = function (projectId) {
            var project = _.find(_this.props.projects, function (project) { return project._id === projectId; });
            var projectHours = _this.props.projectsGPSHoursMap.find(function (item) {
                return item.projectId === projectId;
            });
            return React.createElement(projectWorklogs_1.default, { key: projectId, project: project, totalWorkTime: projectHours && projectHours.totalWorkTime || 0, totalTravelTime: projectHours && projectHours.totalTravelTime || 0, worklogs: projectWorkLogs[projectId], updateWorkLog: function (worklog) { return _this.updateWorkLogHandler(worklog); }, getWorkLogPermission: function (worklog) { return _this.getWorkLogPermission(worklog); }, addWorkLog: function () { return _this.addWorkLog(project); }, getProjectTypes: function (worklog) { return _this.getProjectTypes(projectId, worklog); }, editable: !_this.props.isApproved });
        };
        var renderSpecialWorkLogs = function () {
            return React.createElement(SpecialWorklogs_1.default, { worklogs: specialWorkLogs, getSpecialTypes: function (worklog) { return _this.getSpecialTypes(worklog); }, updateWorkLog: function (event) { return _this.updateWorkLogHandler(event); }, getWorkLogPermission: function (worklog) { return _this.getWorkLogPermission(worklog); }, editable: !_this.props.isApproved, onEditClick: function (worklog) {
                    return _this.setState({ selectedSpecialType: worklog }, function () { return _this.setState({ showSpecialTypesModal: true }); });
                } });
        };
        return (React.createElement("div", { className: "worklog-column" },
            React.createElement(index_1.Column, null,
                !this.props.isApproved && addButtons,
                React.createElement("div", { className: "detail-worklog" },
                    this.props.isClosed &&
                        React.createElement("div", { className: "alert-container info" },
                            React.createElement("span", null, "Werkdag was gesloten door app gebruiker"),
                            this.props.closeMessage &&
                                React.createElement("p", null,
                                    "Commentaar: ",
                                    this.props.closeMessage)),
                    this.props.worklogs.length === 0 && React.createElement(index_1.Center, null,
                        " ",
                        constants_1.NO_DATA_MESSAGE,
                        " "),
                    (Object.keys(projectWorkLogs).length > 0 || specialWorkLogs.length > 0)
                        && this.renderWorkLogTableHeader(),
                    React.createElement(index_1.Wrapper, null,
                        Object.keys(projectWorkLogs).map(function (projectId) { return renderProjectWorkLogs(projectId); }),
                        specialWorkLogs.length > 0 && this.renderWorkLogTableHeader(true) &&
                            renderSpecialWorkLogs())),
                React.createElement(index_1.Wrapper, { padding: "8px" },
                    React.createElement("div", { className: "worklog-summary" }, this.renderSummary()),
                    React.createElement(index_1.Margin, { margin: "8px" })))));
    };
    return WorkLogs;
}(React.Component));
var mapStateToProps = function (_, ownProps) {
    var workTypes = _.reducer.authentication.workTypes;
    return __assign({ identity: _.reducer.authentication.user, projectTypes: workTypes ? workTypes.projectTypes : [], specialTypes: workTypes ? workTypes.specialTypes : [], blockedProjectTypes: (workTypes && workTypes.blockedProjectTypes) || [], blockedSpecialTypes: (workTypes && workTypes.blockedSpecialTypes) || [] }, ownProps);
};
var mapDispatchToProps = function (dispatch) { return ({
    createWorkLog: function (worklog) {
        return dispatch(actions_1.Actions.createWorkLog(worklog));
    },
    updateWorkLog: function (worklog) {
        return actions_1.Actions.updateWorkLog(worklog)(dispatch);
    },
    deleteWorkLog: function (worklog) {
        return dispatch(actions_1.Actions.deleteWorkLog(worklog));
    },
}); };
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(WorkLogs);
